


















































































/* eslint-disable */
import { Vue, Component, Prop } from "vue-property-decorator";
import { parse, ParseError } from "papaparse";
import BaseView from "@/components/BaseView.vue";
import BaseDataForm from "@/components/batch/BaseDataForm.vue";
import { RawBatch, RawRequestBody, RawRequest } from "@/store/batch/types";
import RequestList from "@/components/batch/RequestList.vue";
import NewBatchSummary from "@/components/batch/NewBatchSummary.vue";
import Spinner from "@/components/Spinner.vue";
import batch from "../../store/batch/index";
import { format, validate } from "rut.js";

@Component({
  components: {
    BaseView,
    BaseDataForm,
    RequestList,
    NewBatchSummary,
  },
})
export default class BatchNew extends Vue {
  // Vuex store with lightweight typed wrapper
  readonly store = this.$store.direct;
  // Component constants
  readonly title = "Nueva Carga";
  readonly subtitle = "Crear una nueva carga de documentos";
  readonly info = null;
  // Component variables
  step: number = 1;
  // Component methods
  saveBaseData(data: Partial<RawBatch>) {
    this.store.commit.batch.UPDATE_SELECTED(data);
    this.store.commit.batch.CLEAR_REQUESTS_FROM_SELECTED();
    this.step = 2;
    this.parseFile();
  }

  async create() {
    let result = await this.store.dispatch.batch.create();
    if (result.error) {
      this.store.commit.PUSH_MESSAGE({
        message: "No se pudo crear la carga. Intente nuevamente.",
        type: "error",
      });
    } else {
      this.store.commit.PUSH_MESSAGE({
        message: "La carga se ha creado correctamente.",
        type: "success",
      });
      this.store.commit.batch.CLEAR_SELECTED();
      this.$router.push("/batches");
    }
  }

  back() {
    this.store.commit.batch.CLEAR_REQUESTS_FROM_SELECTED();
    this.step = 1;
  }

  cancel() {
    this.store.commit.batch.CLEAR_SELECTED();
    this.$router.back();
  }

  parseFile() {
    if (this.store.state.batch.selected.source) {
      this.store.commit.START_LOADING();
      parse(this.store.state.batch.selected.source, {
        header: true,
        worker: true,
        complete: (results) => {
          if (results && results.data) {
            results.data.forEach((row: any, index) => {
              let { parsed, errors } = this.parseRow(row, index);
              let payload = {
                request: parsed,
                errors: results.errors
                  .filter((err) => {
                    return err.row == index;
                  })
                  .concat(errors),
              };
              this.store.commit.batch.ADD_REQUEST_TO_SELECTED(payload);
            });
          }
          this.store.commit.END_LOADING();
        },
      });
    }
  }

  parseRow(row: { [key: string]: string }, index: number) {
    let parsed: RawRequestBody = {
      email: "",
      company: {
        name: "",
        rut: "",
      },
      variables: [],
      templates: [],
    };

    let errors: ParseError[] = [];

    Object.keys(row).forEach((key) => {
      if (key.toLowerCase() == "email" && parsed.email.length == 0) {
        if (row[key].length > 0) {
          parsed.email = row[key].toLowerCase();
        } else {
          errors.push({
            row: index,
            code: "EmailEmpty",
            type: "FieldValidation",
            message: "Field email is required and cannot be an empty string",
          });
        }
        return parsed.variables.push({
          name: "email",
          value: row[key],
        });
      }
      if (
        key.toLowerCase() == "razon_social" &&
        parsed.company.name.length == 0
      ) {
        if (row[key].length > 0) {
          parsed.company.name = row[key];
        } else {
          errors.push({
            row: index,
            code: "RazonSocialEmpty",
            type: "FieldValidation",
            message:
              "Field razon_social is required and cannot be an empty string",
          });
        }
        return parsed.variables.push({
          name: "razon_social",
          value: row[key],
        });
      }
      if (key.toLowerCase() == "rut_e" && parsed.company.rut.length == 0) {
        if (row[key].length == 0) {
          errors.push({
            row: index,
            code: "RutEEmpty",
            type: "FieldValidation",
            message: "Field rut_e is required and cannot be an empty string",
          });
        } else if (!validate(row[key])) {
          errors.push({
            row: index,
            code: "RutEENotValid",
            type: "FieldValidation",
            message: "Field rut_e must be a valid RUT",
          });
        } else {
          parsed.company.rut = format(row[key]);
        }
        return parsed.variables.push({
          name: "rut_e",
          value: format(row[key]),
        });
      }
      if (key.toLowerCase().startsWith("v_")) {
        return parsed.variables.push({
          name: key.substring(2).toLowerCase(),
          value: row[key],
        });
      }
      if (key.toLowerCase().startsWith("t_") && row[key] == "X") {
        return parsed.templates.push(key.substring(2));
      }
    });

    if (parsed.email.length == 0) {
      errors.push({
        row: index,
        code: "EmailMissing",
        type: "FieldMissing",
        message: "Required field email not found",
      });
    }
    if (parsed.company.name.length == 0) {
      errors.push({
        row: index,
        code: "RazonSocialMissing",
        type: "FieldMissing",
        message: "Required field razon_social not found",
      });
    }
    if (parsed.company.rut.length == 0) {
      errors.push({
        row: index,
        code: "RutEMissing",
        type: "FieldMissing",
        message: "Required field rut_e not found",
      });
    }

    return { parsed, errors };
  }
}
